let mql = window.matchMedia('(min-width: 992px)');

export const SiteHeader = () => ({
	mobileOpen: false,
	childNav: 0,
	bodyElem: null,

	init() {
		this.bodyElem = document.querySelector('body');
		window.addEventListener("resize", this.onResizeFunction);
	},

	toggleMobileNav() {
		if (this.mobileOpen) {
			this.mobileOpen = false;
			this.childNav = 0;
			this.bodyElem.dataset.state = 'scroll';
		} else {
			this.mobileOpen = true;
			this.bodyElem.dataset.state = 'noscroll';
		}
	},

	onResizeFunction() {
		const bodyElem = document.querySelector('body');
		if (mql.matches) {
			bodyElem.dataset.state = 'scroll';
		}
	}
});
